import { render } from "./HistoricoMatricula.vue?vue&type=template&id=20856c88&scoped=true"
import script from "./HistoricoMatricula.vue?vue&type=script&lang=js"
export * from "./HistoricoMatricula.vue?vue&type=script&lang=js"

import "./HistoricoMatricula.vue?vue&type=style&index=0&id=20856c88&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20856c88"]])

export default __exports__